import { queryClient } from '../../../ReactQuery';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { put } from '../../../redux/api';
import type {
  UpdateReportOptionRequest,
  UpdateReportOptionResponse,
} from '../../../../shared/types/routes/reportOptions';

import { getReportOptionsQueryKey } from './useReportOptions';

type UpdateReportOptionVariables = {
  id: number;
  data: UpdateReportOptionRequest;
};

function updateReportOption({
  id,
  data,
}: UpdateReportOptionVariables): Promise<Response & { data?: UpdateReportOptionResponse }> {
  return put<UpdateReportOptionRequest, UpdateReportOptionResponse>(`/api/report-options/${id}`, data);
}

/**
 * Hook for updating an existing saved report option (save or rename).
 *
 * @param organizationId - Used to invalidate the report options query cache after update.
 */
export function useUpdateReportOption(organizationId: number) {
  return useToastedMutation({
    mutationFn: updateReportOption,
    successToastMessage: 'Report option updated successfully.',
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getReportOptionsQueryKey(organizationId) });
    },
  });
}
